import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import Icon from "new_components/atoms/Icon";
import colors from "styles/colors";

// Wrapper for the Icon with Background
const IconBackground = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size + 16}px;
  height: ${({ size }) => size + 16}px;
  background-color: ${({ bgColor, hoverParent }) =>
    hoverParent ? colors.primary[100] : bgColor || colors.primary[50]};
  border-radius: 8px;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: background-color 0.2s ease; // Smooth background transition
`;

const IconWithBackground = ({
  name,
  size = 24,
  color,
  bgColor,
  hoverParent = false,
  onClick,
  hidden = false,
  disabled,
  ...props
}) => {
  return (
    <IconBackground
      size={size}
      bgColor={bgColor}
      hoverParent={hoverParent}
      onClick={onClick}
      disabled={disabled}
      hidden={hidden}
    >
      <Icon
        name={name}
        size={size}
        {...props}
        fill={color || colors.primary[500]}
        style={{
          pointerEvents: onClick ? "auto" : "none",
          cursor: onClick ? "pointer" : "default",
        }}
      />
    </IconBackground>
  );
};

IconWithBackground.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  hoverParent: PropTypes.bool,
  onClick: PropTypes.func,
};

export default IconWithBackground;